import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../../styles/clients/login.css";
import { showToast } from '../../utils/toastUtils';
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as LogoSvg } from "../../assets/icons/Logo.svg";
import { Eye, EyeOff } from "lucide-react";
import { CircleChevronLeft } from "lucide-react";
import { AuthService } from "../../services/auth";
import { UserRole } from "../../context/AuthContext";

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    // Kiểm tra định dạng email cơ bản để tránh những lỗi dễ thấy
    const looksLikeEmail = /.+@.+\..+/.test(username);
    if (!looksLikeEmail) {
      showToast.error("Vui lòng nhập email hợp lệ.");
      return;
    }

    try {
      const data = await AuthService.login({ email: username, password });

      const accessToken: string = data.access_token;
      const backendRole: string = data.user.role;

      if (accessToken) {
        try {
          localStorage.setItem("access_token", accessToken);
        } catch {}
      }

      // Tạo đối tượng người dùng với thông tin từ backend
      const userData = {
        id: data.user.id,
        email: data.user.email,
        fullName: data.user.fullName,
        isActive: data.user.isActive,
        role: backendRole as UserRole,
      };

      login(userData);
      showToast.success("Đăng nhập thành công!");
      setTimeout(() => {
        navigate("/");
      }, 1200);
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Không thể kết nối máy chủ. Vui lòng thử lại sau.";
      showToast.error(errorMessage);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <img
          src={require("../../assets/images/image-login.png")}
          alt="illustration"
          className="illustration-full"
        />
      </div>
      <div className="login-right">
        <div className="back-home-link-wrapper">
          <button
            type="button"
            className="back-home-link"
            onClick={() => navigate("/")}
          >
            <CircleChevronLeft size={18} className="back-home-link-icon" />
            <span className="back-home-link-text">Quay lại tin tức</span>
          </button>
        </div>
        <div className="login-logo">
          <LogoSvg
            style={{ width: "300", height: "100", marginBottom: "2rem" }}
          />
        </div>
        <h1 className="login-title">Đăng nhập hệ thống</h1>
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Nhập email của bạn</label>
            <input
              id="email"
              type="email"
              placeholder="Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Nhập mật khẩu của bạn</label>
            <div className="input-password-wrapper">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Mật khẩu"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword((v) => !v)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </span>
            </div>
          </div>
          <div className="login-actions">
            <button
              type="button"
              className="forgot-password"
              onClick={() => navigate("/quen-mat-khau")}
            >
              Quên mật khẩu ?
            </button>
          </div>
          <div className="action-container">
            <button className="action-btn" type="submit">
              Đăng nhập
            </button>
            <div className="register-link">
              Chưa có tài khoản?
              <button
                type="button"
                className="register-text"
                onClick={() => navigate("/dang-ky")}
              >
                Đăng ký ngay
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
